import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {Stack, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization';
///import ProfessionalDetails from '../components/ProfessionalDetails';
import AgentSave from './AgentSave';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
//import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

	var vertical='top',horizontal='center';
  
  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	
	const childRefDetails = React.useRef();
	const childRefSave = React.useRef();
	const childRefAuthorization = React.useRef();
	const [privileges, setPrivileges] = React.useState("");
	
	
	const [dataLoading, setDataLoading] = React.useState(true);

	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");


	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'id', headerName: '#', width: 40 },
		{ field: 'fullName', headerName: 'Full Name', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'mobile', headerName: 'Mobile', width: 160 },   
		{ field: 'email', headerName: 'Email', width: 200 },
		{ field: 'salesTarget', headerName: 'Sales Target', width: 160 },
		{ field: 'reportToName', headerName: 'Report To', width: 200 },
		{field: 'roleName', headerName: 'Role', width: 160, hide:userObj.packageId>1?false:true},		
		{ field: 'employeeNumber', headerName: 'Employee Number', width: 200 },
		{ field: 'userType', headerName: 'Admin', width: 120, hide:userObj.packageId>1?false:true ,
			renderCell: (cellValues) => {
				return <span>{cellValues.row.userType===1?<><i className="fa fa-check-square-o" style={{fontSize:15}} ></i></>:<><i className="fa fa-square-o" style={{fontSize:15}} ></i></>}</span>
			  },
		  }, 
		{ field: 'active', headerName: 'Active', width: 120 ,
			renderCell: (cellValues) => {
				return <span>{cellValues.row.active===1?<><i className="fa fa-check-square-o" style={{fontSize:15}} ></i></>:<><i className="fa fa-square-o" style={{fontSize:15}} ></i></>}</span>
			  },
		  },
		{ field: 'otpMobileNumber', headerName: 'OTP Mobile Number', width: 200, hide:userObj.packageId>1?false:true },
		{ field: 'otpLogin', headerName: 'OTP Login', width: 140, hide:userObj.packageId>1?false:true ,
		renderCell: (cellValues) => {
			return <span>{cellValues.row.otpLogin===1?<><i className="fa fa-check-square-o" style={{fontSize:15}} ></i></>:<><i className="fa fa-square-o" style={{fontSize:15}} ></i></>}</span>
		  },
	  	}, 

	  ];
	

	React.useEffect(() => {		
		// alert("registerId: "+userObj.registerId);
		// alert("token: "+userObj.token);
		if(userObj.registerId && userObj.loginId && userObj.fullName && userObj.token){
			getApiData(userObj.registerId,userObj.loginId,userObj.fullName,userObj.token);
		}
	}, [userObj,filter]);

	async function getApiData(registerId,uid,fullName,token){ 
		  let apiUrl=API_URL+'/crm-list-crmusers?keyword='+keyword;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': registerId,
					'uid': uid,
					'fullName': fullName,
					'token': token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){  
				 	setRows(response.data.list);				 			
					setPrivileges(response.data.privileges);	
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				setSeverityAlert("error");
			    setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
		  	})	
	}

	
	function saveData(opt){
		if(opt===1){
			setDataObj(null);
			childRefSave.current.handleClickOpen();
		}else if(opt===2){
			childRefSave.current.handleClickOpen();
		}else if(opt===3){
			childRefDetails.current.handleClickOpen();
		}
	}
	
	function deleteData(){
		if(dataObj && userObj.token){
			let axiosHeader = {
					headers: {
						'Content-Type': 'multipart/mixed',
						'device': 'web',
						'registerId': userObj.registerId,
						'uid': userObj.loginId,
						'fullName': userObj.fullName,
						'token': userObj.token,
				}
			}; 

		  const data = new FormData();
		  data.append('id', dataObj.autoId);
		  data.append('loginId', dataObj.loginId);
				 
		  axios.post(API_URL+'/crm-delete-crmusers', data, axiosHeader)
				.then((response) => {
					////console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Agent has been deleted.");
			  		window.location.reload();	
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This agent could not be deleted.");			
					return false;
				}
			})
				.catch((error) => {
					setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
				})	
		}		
		
	}

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
		}
	}

	function search(){
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}

	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function hideAlert(){
		setShowAlert(false);
	}
	
	return (
		<div> 
				<MetaTags>
            		<title>Agents</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Agents" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

				    <Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} >

									<FormControl style={{width:150,marginRight:60,float:'left'}}>
										<OutlinedInput 
										 id="keywordtxt"
										 placeholder="Search"
										 value={keyword}
										 onChange={event => setKeyword(event.target.value)}
										 onKeyPress={(event)=>{onEnter(event)}}
										 style={{width:200,height:40}}
										 endAdornment={
											  <InputAdornment position="end">
												<SearchIcon />
											  </InputAdornment>
											}
										 />
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop:4,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>

									<div style={{float:'left'}}>	
										{(privileges && privileges.indexOf("create")>-1)?	
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}	
									{selectedRow>0?<>
										{(privileges && privileges.indexOf("update")>-1)?	
											<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										{(privileges && privileges.indexOf("delete")>-1)?
											<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										{/* <i onClick={()=>{saveData(3)}} title="Detail" className="fa fa-info-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} /> */}
									</>:null}

									</div>	
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '78vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={50}
							rowHeight={40}
							rowsPerPageOptions={[50]}
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}	
							onRowClick={itm => selectRow(itm)}			
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No agents found!</span>
								  </Stack>
								)}}	
						/>
					</div>

				</Box>
				
			<AgentSave dataObj={dataObj} userObj={userObj} ref={childRefSave} />

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete agent.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>
					
				<Authorization ref={childRefAuthorization} />
		</div>	
	);
  }